<div class="container d-flex justify-content-md-center align-items-center vh-100">
  <div class="blankpage-form-field">
    <div class="page-logo m-0 w-100 align-items-center justify-content-center rounded border-bottom-left-radius-0 border-bottom-right-radius-0 px-4">
      <i class="fal fa-tachometer-alt-average fa-2x color-primary-50"></i>
      <span class="page-logo-text mr-1">{{brandName}}</span>
    </div>
    <div class="card p-4 border-top-left-radius-0 border-top-right-radius-0">
      <form [formGroup]="loginForm" (ngSubmit)="onSubmit()">
        <div class="form-group">
          <input type="text" formControlName="username" class="form-control" placeholder="Username"
                 [ngClass]="{ 'is-invalid': submitted && form.username.errors }"/>
          <div *ngIf="submitted && form.username.errors" class="invalid-feedback">
            <div *ngIf="form.username.errors.required">Username is required</div>
          </div>
        </div>
        <div class="form-group">
          <input type="password" placeholder="Password" formControlName="password" class="form-control"
                 [ngClass]="{ 'is-invalid': submitted && form.password.errors }"/>
          <div *ngIf="submitted && form.password.errors" class="invalid-feedback">
            <div *ngIf="form.password.errors.required">Password is required</div>
          </div>
        </div>
        <!--<div class="form-group text-left">
          <div class="custom-control custom-checkbox">
            <input type="checkbox" class="custom-control-input" id="rememberme">
            <label class="custom-control-label" for="rememberme"> Remember me for the next 30 days</label>
          </div>
        </div>-->
        <button [disabled]="loading" class="btn btn-default float-right">
          <span *ngIf="loading" class="spinner-border spinner-border-sm mr-1"></span>
          Secure login
        </button>
        <div *ngIf="error" class="alert alert-danger mt-3 mb-0">{{error}}</div>
      </form>
    </div>
    <!--<div class="blankpage-footer text-center">
        <a href="#"><strong>Recover Password</strong></a> | <a href="#"><strong>Register Account</strong></a>
    </div>-->
    <div class="login-footer p-2">
      <div class="row">
        <div class="col col-sm-12 text-center">
          <!--<i>
              <strong>System Message:</strong>
              You were logged out from 198.164.246.1 on Saturday, March, 2017 at 10.56AM
          </i>-->
        </div>
      </div>
    </div>
  </div>

  <video id="bgvid" playsinline autoplay muted loop *ngIf="showVideo">
    <source src="assets/media/video/cc.webm" type="video/webm">
    <source src="assets/media/video/cc.mp4" type="video/mp4">
  </video>
</div>
